import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';
import { AuthGuard } from './guards';
import { ManagementAppRoutes } from './management';
import ManagementLayout from '../layouts/management';
import { TransporterAppRoutes } from './transporter';
import LogisticsTwo from '../layouts/logisticsTwo';
import { TransportAgentAppRoutes } from './trasnport-agent';
import CustomerLayout from '../layouts/customer';
import { qdpAppRoutes } from './qdp';
import { qdpCustomerAppRoutes } from './qdp/customer';
import LogisticsLayout from '../layouts/logistics';
import LogisticsLayoutTwo from '../layouts/logisticsTwo';
import { pmpAppRoutes } from './pmp';
import { pmpCustomerAppRoutes } from './pmp/customer';
import { slpAppRoutes } from './slp';
import { slpCustomerAppRoutes } from './slp/customer';
import TransportAgentLayout from '../layouts/transport-agent';
import useWindowDimensions from '../hooks/useWindowsDimensions';
import Invoice from '../common/components/invoice';
import EWayBill from '../common/components/ewaybill';
import ManagementRoutes from '../pages/management/route-management/routes/containers/routes';
import { LxRoutes } from './lx/routes';
import LxLayout from '../layouts/lx';


const AppRouter: React.FC = () => {
  let SUBSCRIPTION_TYPE: string = process.env.REACT_APP_SUBSCRIPTION_TYPE || '';
  console.log('SUBSCRIPTION_TYPE', SUBSCRIPTION_TYPE)
  const { height, width } = useWindowDimensions();

  const prepareShipxRoutes = () => {
    const routes: RouteObject[] = [
      {
        path: '/',
        element: <LxLayout />, children: LxRoutes(),
      },
      {
        path: '/transporter/*',
        element: <AuthGuard><LogisticsLayoutTwo /></AuthGuard>, children: TransporterAppRoutes(),
      },
      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },


    ];
    return routes;
  }

  const prepareQDPRoutes = () => {
    const routes: RouteObject[] = [
      {
        path: '/order/invoice/:id',
        element: <Invoice />
      },
      {
        path: '/order/e-way/:id',
        element: <EWayBill />
      },
      {
        path: '/',
        element: <LogisticsLayout />, children: qdpAppRoutes({ width }),
      },
      {
        path: '/customer/*',
        element: <AuthGuard><CustomerLayout /></AuthGuard>, children: qdpCustomerAppRoutes({ width }),
      },
      {
        path: '/transport-agent/*',
        element: <AuthGuard><TransportAgentLayout /></AuthGuard>, children: TransportAgentAppRoutes({ width }),
      },
      {
        path: '/transporter/*',
        element: <AuthGuard><LogisticsLayoutTwo /></AuthGuard>, children: TransporterAppRoutes(),
      },

      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },

    ];
    return routes;
  }

  const preparePMPRoutes = () => {
    const routes: RouteObject[] = [
      {
        path: '/',
        element: <LogisticsLayout />, children: pmpAppRoutes(),
      },
      {
        path: '/customer/*',
        element: <AuthGuard><CustomerLayout /></AuthGuard>, children: pmpCustomerAppRoutes(),
      },
      {
        path: '/transport-agent/*',
        element: <AuthGuard><TransportAgentLayout /></AuthGuard>, children: TransportAgentAppRoutes({ width }),
      },
      {
        path: '/transporter/*',
        element: <AuthGuard><LogisticsTwo /></AuthGuard>, children: TransporterAppRoutes(),
      },

      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },

    ];
    return routes;
  }

  const prepareSLPRoutes = () => {
    const routes: RouteObject[] = [
      {
        path: '/',
        element: <LogisticsLayout />, children: slpAppRoutes(),
      },
      {
        path: '/customer/*',
        element: <AuthGuard><CustomerLayout /></AuthGuard>, children: slpCustomerAppRoutes(),
      },
      {
        path: '/transport-agent/*',
        element: <AuthGuard><TransportAgentLayout /></AuthGuard>, children: TransportAgentAppRoutes({ width }),
      },
      {
        path: '/transporter/*',
        element: <AuthGuard><LogisticsTwo /></AuthGuard>, children: TransporterAppRoutes(),
      },

      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },

    ];
    return routes;
  }
  //Test-local

  // const testLocal = 'https://ulip.ishipx.digiit.io/'

  // if (testLocal.includes('ishipx')) {
  //   console.log('Running DBA');
  //   return <RouterProvider router={createBrowserRouter(prepareShipxRoutes())} />
  // }

  if (window.location.hostname.includes('ishipx')) {
    console.log('Running DBA');
    return <RouterProvider router={createBrowserRouter(prepareShipxRoutes())} />
  }
  switch (SUBSCRIPTION_TYPE) {
    case 'QDP':
      console.log('Running QDP')
      return (
        <RouterProvider router={createBrowserRouter(prepareQDPRoutes())} />
      );
    case 'PMP':
      console.log('Running PMP')
      return (
        <RouterProvider router={createBrowserRouter(preparePMPRoutes())} />
      );
    case 'SLP':
      console.log('Running SLP')
      return (
        <RouterProvider router={createBrowserRouter(prepareSLPRoutes())} />
      );
    default:
      return null
  }

};

export default AppRouter;
